import React, { Component } from 'react';
import { config } from '../../config';
import Grid from '../../components/Grid/Grid';
import Header from '../../components/Promotion/Header/Header';
import { withPromotions } from '../../contextApi';
import { formatDateFromFirebase } from "../../utils/date";
import { TableRowPromotion } from "../../components/Common/Table/rows";
import GridPage from "../GridPage";
import MultiSelect from "../../components/Engine/Common/MultiSelect/MultiSelect";

const tableHead = ['Promotion Id', 'Banner', 'Title', 'Start Date', 'End Date', 'Actions'];
const timePeriodsRaw = ['Expired', 'Current', 'Upcoming'];
const timePeriods = timePeriodsRaw.map(x => ({ value: x, label: x }));
const defaultFilters = {
  isMallEvent: false,
};

class Promotions extends Component {
  state = {
    type: config.statuses.any,
    types: [config.statuses.any],
    merchantId: config.statuses.any,
    tableData: [],
    active: true,
  };

  constructor(props) {
    super(props);

    this.renderRow = this.renderRow.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getFilterControls = this.getFilterControls.bind(this);
  }

  componentDidMount() {
    const { setPromotionsProviderActive } = this.props;
    setPromotionsProviderActive();

    this.setState(prevState => ({
      ...prevState,
      timePeriods,
    }));
  }

  static getTableRowData(promotion) {
    const {
      id,
      title,
      image,
      creationDate: creation,
      startDate: start,
      endDate: end,
      imageFileName,
      hasBeenActive,
    } = promotion;
    const allowDelete = !hasBeenActive;
    const startDate = formatDateFromFirebase(start);
    const endDate = formatDateFromFirebase(end);
    const creationDate = formatDateFromFirebase(creation);
    const row = {
      id,
      title,
      creationDate,
      startDate,
      endDate,
      imageFileName,
      hasBeenActive,
      allowDelete,
      image,
    };
    return row;
  }

  async onDelete(id) {
    const { deletePromotionById } = this.props;

    await deletePromotionById(id);
  }

  getFilterControls(filterValues) {
    const { timePeriods } = this.state;
    // console.log(`MallEvents.getFilterControls(${JSON.stringify(filterValues)})`);
    const { timePeriod = [] } = filterValues;

    return [
      <MultiSelect
        id="timePeriod"
        targetName="timePeriod"
        isMainPage={true}
        name="Time period"
        options={timePeriods}
        value={timePeriod.map(x => ({label: x, value: x}))}
        key="timePeriod"
      />
    ]
  }

  renderRow(item) {
    const { location } = this.props;
    const { pathname } = location;
    const { id } = item;

    return (
      <TableRowPromotion
        el={item}
        pathname={pathname}
        key={id}
        onDelete={this.onDelete}
        itemName="promotion"
        imageNamePrefix={`${id}_`}
      />
    );
  }

  render() {
    const { promotions, getFilteredPromotions } = this.props;

    return (
      <GridPage
        viewName="Promotions"
        itemName="Promotion"
        pathname="promotions"
        // filterData={merchants.length} // TODO : this should be a hash
        items={promotions}
        getFilterControls={this.getFilterControls}
        getFilteredItems={getFilteredPromotions}
        getTableRowData={Promotions.getTableRowData}
        renderRow={this.renderRow}
        tableHead={tableHead}
        filters={defaultFilters}
      />
    )
  }
}

export default withPromotions(Promotions);
